/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import { createListenerMiddleware } from '@reduxjs/toolkit';
import map from 'lodash/map';

import { IOptionItemProps } from '@components/common/Select/Select';
import { API_REPORTS_SUBSCRIBER_EDIT_META } from '@modules/app/Api';
import { ICommonTranslation } from '@modules/internationalization/types';
import { tableApi } from '@modules/table/store';

export const tableReportsSubscriberListenerMiddleware = createListenerMiddleware();

/*
*  В запросе meta для таблицы заказов facets для фильтра-select приходят как массивы строк
*  Массив строк нужно привести к стандартному виду label value
*  Для некоторых колонок значения устанавливаются на фронте
*/

export const tableReportsSubscriberListenerStart = ({ select }: ICommonTranslation) => {
    tableReportsSubscriberListenerMiddleware.startListening({
        matcher: tableApi.endpoints.getTableMeta.matchFulfilled,
        effect: ({ payload }, listenerApi) => {
            const {
                /* Для колонок с типом фильтра-select необходимо массив строк привести к виду label & value */
                loyaltyStatus,
            } = (payload.facets || {});

            /* Для колонок "Предложения" необходимо добавить фильтры "Нет" и "Есть" */
            const campaignsOptions: IOptionItemProps[] = [
                /* Нет */
                { label: select.noExist, value: 0 },
                /* Есть */
                { label: select.exist, value: 1 },
            ];

            listenerApi.dispatch(
                // @ts-ignore
                tableApi.util.updateQueryData('getTableMeta', { url: API_REPORTS_SUBSCRIBER_EDIT_META }, (draft) => {
                    if (draft.facets) {
                        draft.facets.assistantCampaignsCount = campaignsOptions;
                        draft.facets.coordinatorCampaignsCount = campaignsOptions;
                        draft.facets.loyaltyStatus = map(loyaltyStatus, option => ({ label: option, value: option }));
                    }
                }),
            );
        },
    });
};
